<app-map-view [IsHistorical]="true"></app-map-view>
